module.exports = __webpack_public_path__ + "img/superiores.d2f4df73.jpg";